/**
 * @file    initLoginType
 * @authors KevinChan (chj@8cuo.net)
 * @date    2023/11/21 18:09:54
 */
function initType (domain) {
  localStorage.setItem('loginType', domain);
  window.loginType = domain
  if (window.siteConfig) {
    return window.siteConfig
  } else {
    // let domain = localStorage.getItem('loginType');
    let config = {
      loginBack: 'static/images/login/bg.jpg',
      loginText: 'SPARK管理后台',
      ico: 'static/images/favicon.ico',
      title: 'SPARK影像住培教学平台',
      showDownBtn: true,
      logoUrl: 'static/images/SPARK-LOGO.png',
      logoText: 'SPARK影像住培教学平台'
    };
    let xhr = new XMLHttpRequest();
    xhr.open('GET', 'static/siteConfig/' + domain, false);
    xhr.send(null);

    if (xhr.status === 200) {
      try {
        let siteConfig = JSON.parse(xhr.responseText);
        if (siteConfig) {
          config = Object.assign(config, siteConfig)
          // localStorage.setItem('lang', config.lang || 'zh')
        }
      } catch (error) {
        // console.log(error);
      }
    } else { }
    if (config.ico && window.baseUrl) {
      config.ico = window.baseUrl + config.ico
    }
    if (config.logoUrl && window.baseUrl) {
      config.logoUrl = window.baseUrl + config.logoUrl
    }
    window.siteConfig = config;
    // return config;
    // console.log(config);
    document.title = window.siteConfig.title
    // console.log(this.config.title)
    if (window.siteConfig.ico) {
      let link = document.getElementById('ico-link')
      link.href = window.siteConfig.ico
      link.type = ''
      link.type = 'image/x-icon'
    }
  }
}
export default function () {
  localStorage.removeItem('loginType')
  let host = window.location.host.split(':')[0];
  let url = host;
  console.log(url)
  initType(url);
}



// WEBPACK FOOTER //
// ./src/config/initLoginType.js